// Browser-only helpers: turn a sprite sheet buffer into a canvas.
import { renderSpriteSheet, type SpriteSheet } from "./sprite";
import type { AvatarIdentity } from "@degen/sim/avatar/traits";

export function sheetToCanvas(sheet: SpriteSheet): HTMLCanvasElement {
  const c = document.createElement("canvas");
  c.width = sheet.width;
  c.height = sheet.height;
  c.getContext("2d")!.putImageData(new ImageData(new Uint8ClampedArray(sheet.data), sheet.width, sheet.height), 0, 0);
  return c;
}

const cache = new Map<string, HTMLCanvasElement>();

/** Cached sheet canvas per avatar (keyed by body + seed + traits). */
export function avatarCanvas(av: AvatarIdentity): HTMLCanvasElement {
  const key = `${av.body}:${av.seed}:${JSON.stringify(av.traits)}`;
  let c = cache.get(key);
  if (!c) {
    c = sheetToCanvas(renderSpriteSheet(av));
    cache.set(key, c);
  }
  return c;
}
